import { useEffect, useRef, useCallback } from "react";
import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import DemoSection from "@/components/DemoSection";
import CreatorPOVSection from "@/components/CreatorPOVSection";
import FeaturesSection from "@/components/FeaturesSection";
import SocialProofSection from "@/components/SocialProofSection";
import FinalCTASection from "@/components/FinalCTASection";
import Footer from "@/components/Footer";
import { Toaster } from "sonner";
import { WaitlistProvider } from "@/context/WaitlistContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const mainRef = useRef(null);

  const setupObserver = useCallback(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    const elements = document.querySelectorAll(".reveal, .stagger-children");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const cleanup = setupObserver();
    return cleanup;
  }, [setupObserver]);

  return (
    <WaitlistProvider>
      <div ref={mainRef} className="min-h-screen bg-transparent text-white overflow-x-hidden">
        <a href="#main" className="skip-link">
          Skip to main content
        </a>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: 'hsl(270 18% 8%)',
              border: '1px solid hsl(271 50% 40% / 0.35)',
              color: '#fff',
            },
          }}
        />
        <Header />
        <main id="main" tabIndex={-1}>
          <HeroSection api={API} />
          <ProblemSection />
          <SolutionSection />
          <DemoSection />
          <CreatorPOVSection />
          <FeaturesSection />
          <SocialProofSection api={API} />
          <FinalCTASection api={API} />
        </main>
        <Footer />
      </div>
    </WaitlistProvider>
  );
}

export default App;
